import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient();

// Needed at every auth boundary: logout/login navigate via SPA routing (no
// page reload), so cached queries would otherwise survive an account switch.
export const dropCachedQueriesOnSessionChange = () => queryClient.clear();
